export default {
  DEPARTURE_TIME: 'departureTime',
  STOPS: 'stops',
  CATEGORIES: 'categories',
  SORT_BY: 'sortBy',
  TRIP_OPTIONS: 'tripOptions',
  RECLINE_OPTIONS: 'reclineOptions',
};
